export function mergeFanIntoForm(form, fan) {
  const next = {
    ...form,
    name: fan.name || form.name || "",
    email: fan.email || form.email || "",
  };
  const mapped = {
    phone: fan.phone,
    title: fan.title,
    instagram_handle: fan.instagram_url,
  };
  Object.entries(mapped).forEach(([key, val]) => {
    if (val && !String(next[key] || "").trim()) next[key] = val;
  });
  return next;
}
